// extracted by mini-css-extract-plugin
module.exports = {"background":"ModalPopup_background__T2TGn","modal":"ModalPopup_modal__1tt2d"};